import { Ban, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

// Barra de ações do formulário de OP (footer fixo). Em edição expõe "Cancelar OP"
// (único surface de cancelamento após a remoção do painel lateral da timeline).
export function ProductionOrderFormActions({
  mode,
  pending,
  conflict,
  onCancel,
  onCancelOrder,
}: {
  mode: "create" | "edit";
  pending: boolean;
  conflict: boolean;
  onCancel: () => void;
  onCancelOrder?: () => void;
}) {
  return (
    <div className="-mx-5 -mb-5 mt-2 flex items-center justify-between gap-2 border-t bg-bg-muted-rd px-5 py-3">
      {onCancelOrder ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="text-rd-danger-700"
          onClick={onCancelOrder}
        >
          <Ban className="mr-1 h-4 w-4" /> Cancelar OP
        </Button>
      ) : (
        <span className="flex items-center gap-1 text-[11px] text-text-tertiary">
          <Zap className="h-3 w-3" /> Apenas GESTOR pode criar/editar OPs
        </span>
      )}
      <div className="flex gap-2">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancelar
        </Button>
        <Button type="submit" disabled={pending || conflict}>
          {conflict
            ? "Resolver conflito para salvar"
            : pending
              ? "Salvando…"
              : mode === "edit"
                ? "Salvar"
                : "Criar OP"}
        </Button>
      </div>
    </div>
  );
}
